<template>
	<div class="content-container">
		<HeaderLayout :pagecode="pagecode" :subpagecode="cmd" @eventProblemCode="changePage"></HeaderLayout>
		
	   <div class="content-box">
			<aiTest @eventBack="back" :no="no" v-if="aiTestView"></aiTest>	
			<aiReport @eventBack="back" :no="no" v-if="aiReportView"></aiReport>	
			<userTest :no="no" v-if="userTestView"></userTest>	
			<userReport @eventBack="back" :no="no" v-if="userReportView"></userReport>	
	   </div>
	   <FooterLayout></FooterLayout>
	</div>
</template>

<script>
import aiTest from '@/components/Problem/aiTest'
import aiReport from '@/components/Problem/aiReport'
import userTest from '@/components/Problem/userTest'
import userReport from '@/components/Problem/userReport'
		
import HeaderLayout from '@/components/inc/Header'
import FooterLayout from '@/components/inc/Footer'


export default {
	name: 'ProblemView',
	components: {
  		userTest,
		userReport,
		aiTest,
		aiReport,
		HeaderLayout,
		FooterLayout
	},
	data() {

		  return {
			  	pagecode:'pview',
				no:'',
				cmd:'',
				historyCmds:[],
				img:'',
				compName:'',
				subject:'',
				aiReportView:false,
				aiTestView:false,
				userReportView:false,
				userTestView:false,
		  }
	},
	created() {
		this.no = this.$route.params.no;
		this.cmd = this.$route.params.cmd;
		if(!this.no) {
			this.$router.go(-1);
			return;
		}
		this.historyCmds.push(this.cmd);
		this.changePage(this.cmd);

	},
    methods: {
		changePage(code) {
			switch(code) {
				case 'aireport':
					this.userTestView = false;
					this.userReportView = false;
					this.aiTestView = false;
					this.aiReportView = true;

				break;
				case 'ai':
					this.userTestView = false;
					this.userReportView = false;
					this.aiTestView = true;
					this.aiReportView = false;

				break;
				case 'mereport':
					this.userTestView = false;
					this.userReportView = true;
					this.aiTestView = false;
					this.aiReportView = false;

				break;
				case 'me':
					this.userTestView = true;
					this.userReportView = false;
					this.aiTestView = false;
					this.aiReportView = false;
				break;
			}
			this.cmd = code;
			this.historyCmds.push(code);
		},
		back() {
			this.historyCmds.pop();
			var last = this.historyCmds.length-1;
			this.cmd = this.historyCmds[last];
			this.changePage(this.cmd);
			
		}
	},
	mounted() {
		
	},
	updated() {
		
	}

}
</script>

<style lang="scss" scoped>
.content-container {
	width:100%;
	max-width:100%;
	min-height:calc(100vh);
	overflow-x:hidden;
	
	
}
</style>